export const fetchPages = resp => ({
  type: "FETCH_PAGES",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/page.js